import Int64LookupResourceListResultModel from '../../generated/types/model/resource/Int64LookupResourceListResultModel';

export default class Int64LookupResourceListResultViewModel extends Int64LookupResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
